import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router } from "@angular/router";
import { lastValueFrom } from "rxjs";
import { catchError, of } from "rxjs";
import { ONBOARDING_ENABLED } from "src/app/tokens/onboarding-enabled.token";
import { UserBackend } from "src/app/backend/api/user.backend";
import { sntLog } from "src/app/common/logger";
import { getCurrentDomainName } from "src/app/core/domain-name";

const logger = sntLog("OnboardingGuard");

export class OnboardingGuard implements CanActivate {
  readonly #userBackend = inject(UserBackend);
  readonly #router = inject(Router);
  readonly #onboardingEnabled = inject(ONBOARDING_ENABLED);

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    logger.info("canActivate");

    if (!this.#onboardingEnabled) {
      logger.info("onboarding disabled");
      return true;
    }

    const domain = getCurrentDomainName();

    const currentMember = await lastValueFrom(
      this.#userBackend
        .loadMemberByDomain({ domain })
        .pipe(catchError(() => of(null)))
    );

    if (!currentMember) {
      logger.info("to onboarding");
      this.#router.navigate(["/", "onboarding", domain]);
      return false;
    }

    logger.info("continue");
    return true;
  }
}
